export default __webpack_public_path__ + "static/media/medium-dificulty.a23ac3a3.svg";